import { useEffect, useState, FC } from 'react';
import { Modal, InputSelect } from '@wajeez-web/components/ui';
import { useParams } from 'react-router-dom';
import { CommonModalProps } from './Types';
// import { useAppSelector } from '../../redux/hooks';

interface SetItemTemplateModalProps extends CommonModalProps<string> {
  validItemTemplates?: number[] | null;
}

const SetItemTemplateModal: FC<SetItemTemplateModalProps> = ({
  isOpen,
  data,
  onClose,
  onSubmit,
  validItemTemplates,
}) => {
  // const { components } = useAppSelector((state) => state.components);
  const { type } = useParams() as { type: string };
  const [itemTemplateId, setItemTemplateId] = useState('');

  useEffect(() => {
    data && setItemTemplateId(data);
  }, [data]);

  return (
    <Modal
      title={'Set Item Template'}
      open={isOpen}
      onClose={onClose}
      onSubmit={() => {
        onSubmit && onSubmit(itemTemplateId);
      }}
    >
      <InputSelect
        name={'Set-Item-Template'}
        label={'Set Item Template'}
        options={
          []
          // components
          // ?.filter(
          //   (item) =>
          //     validItemTemplates &&
          //     validItemTemplates.includes(Number(item.typeId))
          // )
          // .map((item) => ({
          //   label: item.referenceName,
          //   value: item.id,
          // }))
        }
        onChange={(name, value: any) => {
          setItemTemplateId(value?.value);
        }}
        value={
          // itemTemplateId
          //   ? components
          //       ?.map((item) => ({
          //         label: item.referenceName,
          //         value: item.id,
          //       }))
          //       .find(
          //         (item: { value: string; label: string }) =>
          //           item.value === itemTemplateId
          //       )
          //   :
          undefined
        }
      />
    </Modal>
  );
};

export default SetItemTemplateModal;
